<template>
    <div class="post-list">
        <h2 class="text-xl font-bold mb-4">Últimos posteos</h2>
        <div v-if="loading" class="text-center">Cargando...</div>
        <div v-if="!loading && posts.length === 0" class="text-center">No hay posteos disponibles.</div>
        <div v-if="!loading && posts.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div v-for="post in posts" :key="post.id" class="post-item">
                <a :href="post.link" target="_blank"
                    class="block rounded overflow-hidden shadow hover:shadow-lg transition">
                    <img v-if="post.featuredImage" :src="post.featuredImage" :alt="post.title.rendered"
                        class="w-full h-48 object-cover" />
                    <div class="p-4">
                        <h3 class="text-lg font-semibold mb-2" v-html="post.title.rendered"></h3>
                        <p class="text-sm text-gray-600" v-html="post.excerpt.rendered"></p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "PostList",
    data() {
        return {
            posts: [],
            loading: true,
        };
    },
    async mounted() {
        try {
            // Fetch posts from the WordPress API
            const response = await axios.get("https://audiovisual.orsai.org/wp-json/wp/v2/posts", {
                params: {
                    _embed: true, // Include embedded data like featured images
                    per_page: 6, // Limit the number of posts
                },
            });

            // Map the response data to simplify the structure
            this.posts = response.data.map((post) => ({
                id: post.id,
                title: post.title,
                excerpt: post.excerpt,
                link: post.link,
                featuredImage: post._embedded?.["wp:featuredmedia"]?.[0]?.source_url || null,
            }));
        } catch (error) {
            console.error("Error fetching posts:", error);
        } finally {
            this.loading = false;
        }
    },
};
</script>

<style scoped>
.post-list {
    max-width: 1200px;
    margin: 0 auto;
}

.post-item img {
    transition: transform 0.3s;
}

.post-item:hover img {
    transform: scale(1.05);
}
</style>
